<template>
  <div class="form" v-if="getSite">
    <div class="form__body">
      <div class="form__group">
        <select-input
          label="Buy button"
          v-model="form.showBuy"
          :options="siteOptions.buy"
        />
      </div>
      <div class="form__group">
        <select-input
          label="Press section"
          v-model="form.showPress"
          :options="siteOptions.press"
        />
      </div>
      <div class="form__group">
        <select-input
          label="Social links"
          v-model="form.showSocial"
          :options="siteOptions.social"
        />
      </div>
    </div>
    <div class="form__footer">
      <button @click="save" :disabled="isSaving">Save</button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import siteOptions from '@/utilities/siteOptions';
import SelectInput from '@/components/SelectInput.vue';

export default {
  name: 'ManageOptions',
  components: {
    SelectInput,
  },
  computed: {
    ...mapGetters(['getSite']),
  },
  data() {
    return {
      siteOptions,
      form: null,
      isSaving: false,
    };
  },
  created() {
    this.form = this.getSite && this.getSite.options;
  },
  methods: {
    ...mapActions(['update']),
    save() {
      this.isSaving = true;
      this.update({
        model: 'site',
        id: 'options',
        value: this.form,
      }).then(() => {
        this.isSaving = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  max-width: 400px;
  margin: 0 auto;
  &__body {
    padding: 20px;
    background: rgba(0, 0, 0, 0.02);
    margin-bottom: 20px;
  }
  &__group {
    margin-bottom: 20px;
  }
  &__footer {
    text-align: center;
  }
}
</style>
